import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import {Alert, Button} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function TransitionLeft(props) {
  return <Slide {...props} direction='left' />;
}

export default function Notification({
  open,
  handleClose,
  message,
  showCloseButton,
  autoClose,
}) {
  let vertical = 'top';
  let horizontal = 'left';

  return (
    <Snackbar
      dir={'ltr'}
      style={{top: '0', right: '0', width: '100%', borderRadius: '0'}}
      open={open}
      anchorOrigin={{vertical, horizontal}}
      autoHideDuration={autoClose === false ? null : 2000}
      onClose={(event, reason) => {
        if (reason !== 'clickaway') {
          handleClose();
        }
      }}
      TransitionComponent={TransitionLeft}>
      <Alert
        variant='filled'
        severity={message?.type}
        sx={{
          width: '100%',
          color: 'white',
          height: '70px',
          display: 'flex',
          textAlign: 'right',
          paddingLeft: '2rem',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row-reverse',
          fontFamily: 'dana',
          background: message?.type === 'error' && '#d81d5d',
        }}
        action={
          !showCloseButton ? (
            ''
          ) : (
            <Button
              color='inherit'
              size='small'
              sx={{
                left: '10px',
                top: '19px',
                position: 'absolute !important',
              }}
              onClick={handleClose}>
              <CloseIcon />
            </Button>
          )
        }>
        <p
          style={{
            paddingRight: '10px',
            fontSize: '14px',
          }}>
          {message?.text}
        </p>
      </Alert>
    </Snackbar>
  );
}
